import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = { auth: true }

export default {
    path: '/platform',
    name: 'platform',
    meta,
    redirect: { name: 'platform' },
    component: layoutHeaderAside,
    children: (pre => [
        {
            path: 'category',
            name: `${pre}category`,
            component: _import('platform/platformCategory'),
            meta: {
                ...meta,
                title: '设置首页分类'
            }
        },
        {
            path: 'bannerList',
            name: `${pre}bannerList`,
            component: _import('platform/platformBanner'),
            meta: {
                ...meta,
                title: '设置首页广告'
            }
        },
        {
            path: 'youthCategory',
            name: `${pre}youthCategory`,
            component: _import('platform/youthCategory'),
            meta: {
                ...meta,
                title: '邕州未来店铺分类'
            }
        },
    ])('platform-')
}
